import axios from "axios";
import { apis } from "../../core/apis";
import * as appUtils from "../../core/appUtils";

const { api } = apis;

export default {
    namespaced: true,
    state: () => {
        return {
            // 待审核科研项目
            listApplyUnaudited: [],
            // 待审核变更申请
            subjectChangeUnaudited: []
        };
    },
    mutations: {
        updateListApplyUnaudited(state, data) {
            state.listApplyUnaudited = data;
        },
        updateSubjectChangeUnaudited(state, data) {
            state.subjectChangeUnaudited = data;
        }
    },
    actions: {
        getListApplyUnaudited({ commit }) {
            axios
                .post(api.myManage.listApplyForDeptManager, {
                    currentPage: 1,
                    pageSize: 20,
                    where: {
                        "project.type_eq": 2, //科研项目
                        "apply.deptCode_eq": appUtils.getDeptCode() //材料是本校教师提交的
                    },
                    orderBy: {
                        "apply.applySubmit": "desc"
                    }
                })
                .then(res => res.data)
                .then(res => {
                    const { data } = res;
                    commit("updateListApplyUnaudited", data);
                });
        },
        getSubjectChangeUnaudited({ commit }) {
            const deptCode = appUtils.getDeptCode();
            const tenantCode = appUtils.getAppId();
            axios
                .get(api.listApply.getApplySubjectChangeAuditList, {
                    params: { deptCode, tenantCode }
                })
                .then(res => res.data)
                .then(res => {
                    const { data } = res;
                    commit("updateSubjectChangeUnaudited", data);
                });
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/listApply.js